import { render, staticRenderFns } from "./purchasing-organization.vue?vue&type=template&id=33f7c8f4&"
import script from "./purchasing-organization.vue?vue&type=script&lang=js&"
export * from "./purchasing-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports